import { setStyle } from "@remirror/core";
import { EditorView, NodeView, ProsemirrorNode } from "@remirror/pm";
import logger from "../../../../utils/logger";
import { ResizableNodeView, ResizableRatioType } from "prosemirror-resizable-view";
import { Node } from "@remirror/pm/dist-types/model";

/**
 * ZoomImageView is a NodeView for image. You can resize the image by
 * dragging the handle over the image.
 */
export class ResizableZoomableImageView extends ResizableNodeView {
   
    constructor(
        node: ProsemirrorNode,
        view: EditorView,
        getPos: () => number,
        imageStore: { [x: string]: string },
        editable: boolean,
        type: "extension" | "platform" | "videoTranscript" | "helpCenter"
    ) {
        super({
            node,
            view,
            getPos,
            options: {
                editable,
                imageStore,
                type,
            },
        });
    }
    createElement(props: { node: Node; view: EditorView; getPos: () => number; options: any }): HTMLElement {
        const { editable, type, imageStore } = props.options;
        const { node, view, getPos } = props;
        let zoomedIn = true;
        let zoomedInSource = "";
        let zoomFactor = node.attrs.metadata.zoomFactor;

        // this.inner = document.createElement('img')
        const inner = document.createElement("img");
        inner.crossOrigin = 'anonymous'
        // this is for making sure Chrome cache does not serve the request without CORS headers
        // which is what causes the random zoom in not working errors.
        const final = document.createElement("div");


        if (node.attrs.metadata.zoomCenter) {
            //New screenshots
            const zoomCenter = node.attrs.metadata.zoomCenter;
            const zoomCheck = () => {
                // logger.debug(aspectRatio, node.attrs.metadata);
                if (!zoomedIn) {

                    inner.src = node.attrs.src;
                    imageStore[node.attrs.metadata.stepId ?? node.attrs.metadata.stepID] = node.attrs.src;

                }
                if (zoomedIn) {

                    inner.src = zoomedInSource;
                    console.log("SETTING IMAGE STORE SRC")
                    imageStore[node.attrs.metadata.stepId ?? node.attrs.metadata.stepID] = zoomedInSource;
                    
                }
            };
            const regetURL = (dispatch?: boolean) => {
                let img = new Image();
                img.crossOrigin = "anonymous";
                const zoomCenter = node.attrs.metadata.zoomCenter;
                // logger.debug(aspectRatio, node.attrs.metadata);
    
                // create an alternative img url by copying to a canvas
                img.onload = () => {
                    const canv = document.createElement("canvas");
                    canv.height = img.height / zoomFactor;
                    canv.width = img.width / zoomFactor;
                    const ctx = canv.getContext("2d");
                    //@ts-ignore
                    const randomOffset =
                        ((Math.random() * img.width) / zoomFactor) * 0.005 * (Math.random() > 0.5 ? 1 : -1);
                    const sx = Math.min(
                        Math.max(
                            img.width * zoomCenter.x - img.width / (zoomFactor * 2) + randomOffset,
                            // renderedWidth / 2 +
                            // randomOffset,
                            0
                        ),
                        img.width - img.width / zoomFactor
                    );
                    const sy = Math.min(
                        Math.max(img.height * zoomCenter.y - img.height / (zoomFactor * 2), 0),
                        img.height - img.height / zoomFactor
                    );
                    logger.debug(
                        "CANVAS",
                        sx,
                        sy,
                        img.width / zoomFactor,
                        img.height / zoomFactor,
                        0,
                        0,
                        img.width / zoomFactor,
                        img.height / zoomFactor
                    );
                    ctx?.drawImage(
                        img,
                        sx,
                        sy,
                        img.width / zoomFactor,
                        img.height / zoomFactor,
                        0,
                        0,
                        img.width / zoomFactor,
                        img.height / zoomFactor
                    );
                    // const newImageData = ctx?.getImageData(,,renderedWidth, renderedHeight)
                    zoomedInSource = canv.toDataURL("image/jpeg", 1.0);
                    zoomCheck()
                    if (dispatch){

                        view.dispatch(
                            view.state.tr.setNodeAttribute(getPos(), "metadata", {
                                ...node.attrs.metadata,
                                zoomFactor: zoomFactor,
                            })
                        );
                    }
                    // imageStore[
                    //     node.attrs.metadata.stepId ??
                    //         node.attrs.metadata.stepID
                    // ] = zoomedInSource;
                    // logger.debug("IMAGE STORE UPDATED", zoomFactor, this.zoomedInSource)
                };
                img.src = node.attrs.src;
                
            };

            // logger.debug(aspectRatio, node.attrs.metadata);
            if (!imageStore[node.attrs.metadata.stepId ?? node.attrs.metadata.stepID]) {
                regetURL()
            }

            inner.src = imageStore[node.attrs.metadata.stepId ?? node.attrs.metadata.stepID] ?? node.attrs.src;
            inner.className += "gigauser-rich-editor-img";
            // inner.alt = "Loading...";
            setStyle(inner, {
                width: "99%",
                // height: renderedHeight + "px",
                cursor: "pointer",
                minWidth: "50px",
                objectFit: "contain", // maintain image's aspect ratio
            });
    
            

            setStyle(inner, {
                minWidth: "50px",
                cursor: node.attrs.metadata.zoomCenter ? "pointer" : "default",
                //objectFit: "contain", // maintain image's aspect ratio
            });
            // create an alternative img url by copying to a canvas
            if (!editable) {
                //Not editable here
                inner.onclick = () => {
                    
                        zoomedIn = !zoomedIn;
                        zoomCheck();
                    
                };
                return inner
            } else {
                //This is the editable one.
                // regetURL()
                //Not editable here
                var zoomIn = document.createElement("img");
                zoomIn.className = "gigauser-img-zoomIn";
                zoomIn.alt = "Zoom In";
                zoomIn.style.float = "right";
                zoomIn.style.width = "20px";
                zoomIn.style.height = "20px";
                zoomIn.style.borderRadius = "5px";
                zoomIn.style.padding = "3px";
                zoomIn.style.position = "absolute";
                zoomIn.style.bottom = "5px";
                zoomIn.style.right = "7px";
                zoomIn.style.transition = "0.3s";
                zoomIn.style.scale = "0";
                zoomIn.style.backgroundColor = "rgb(153 153 153)";
                zoomIn.src =
                    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 20 20' fill='none'%3E%3Cpath fill='%23ffffff' fill-rule='evenodd' d='M9 17a1 1 0 102 0v-6h6a1 1 0 100-2h-6V3a1 1 0 10-2 0v6H3a1 1 0 000 2h6v6z'/%3E%3C/svg%3E";

                zoomIn.addEventListener("mouseover", (event) => {
                    zoomIn.style.backgroundColor = "rgb(44 43 43)";
                });

                zoomIn.addEventListener("mouseleave", (event) => {
                    zoomIn.style.backgroundColor = "rgb(153 153 153)";
                });

                //ZoomOut
                var zoomOut = document.createElement("img");
                zoomOut.alt = "Zoom Out";
                zoomOut.className = "gigauser-img-zoomOut";
                zoomOut.style.float = "right";
                zoomOut.style.width = "20px";
                zoomOut.style.height = "20px";
                zoomOut.style.borderRadius = "5px";
                zoomOut.style.padding = "3px";
                zoomOut.style.position = "absolute";
                zoomOut.style.bottom = "5px";
                zoomOut.style.right = "36px";
                zoomOut.style.transition = "0.3s";
                zoomOut.style.scale = "0";
                zoomOut.style.backgroundColor = "rgb(153 153 153)";
                zoomOut.src =
                    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 20 20' fill='none'%3E%3Cpath fill='%23ffffff' fill-rule='evenodd' d='M18 10a1 1 0 01-1 1H3a1 1 0 110-2h14a1 1 0 011 1z'/%3E%3C/svg%3E";

                zoomOut.addEventListener("mouseover", (event) => {
                    zoomOut.style.backgroundColor = "rgb(44 43 43)";
                });

                zoomOut.addEventListener("mouseleave", (event) => {
                    zoomOut.style.backgroundColor = "rgb(153 153 153)";
                });

                var deleteIcon = document.createElement("img");
                deleteIcon.alt = "Delete";
                deleteIcon.className="gigauser-img-zoomIn"
                deleteIcon.style.float = "right";
                deleteIcon.style.width = "25px";
                deleteIcon.style.height = "25px";
                deleteIcon.style.borderRadius = "5px"
                deleteIcon.style.padding="3px"
                deleteIcon.style.position="absolute"
                deleteIcon.style.top = "15px";
                deleteIcon.style.right = "7px"
                deleteIcon.style.transition="0.3s"
                deleteIcon.style.scale="0"
                deleteIcon.style.backgroundColor="rgb(153 153 153)"
                deleteIcon.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' width='100' height='100' viewBox='0 0 50 50'%3E%3Cpath fill='%23ffffff' d='M 21 0 C 19.355469 0 18 1.355469 18 3 L 18 5 L 10.1875 5 C 10.0625 4.976563 9.9375 4.976563 9.8125 5 L 8 5 C 7.96875 5 7.9375 5 7.90625 5 C 7.355469 5.027344 6.925781 5.496094 6.953125 6.046875 C 6.980469 6.597656 7.449219 7.027344 8 7 L 9.09375 7 L 12.6875 47.5 C 12.8125 48.898438 14.003906 50 15.40625 50 L 34.59375 50 C 35.996094 50 37.1875 48.898438 37.3125 47.5 L 40.90625 7 L 42 7 C 42.359375 7.003906 42.695313 6.816406 42.878906 6.503906 C 43.058594 6.191406 43.058594 5.808594 42.878906 5.496094 C 42.695313 5.183594 42.359375 4.996094 42 5 L 32 5 L 32 3 C 32 1.355469 30.644531 0 29 0 Z M 21 2 L 29 2 C 29.5625 2 30 2.4375 30 3 L 30 5 L 20 5 L 20 3 C 20 2.4375 20.4375 2 21 2 Z M 11.09375 7 L 38.90625 7 L 35.3125 47.34375 C 35.28125 47.691406 34.910156 48 34.59375 48 L 15.40625 48 C 15.089844 48 14.71875 47.691406 14.6875 47.34375 Z M 18.90625 9.96875 C 18.863281 9.976563 18.820313 9.988281 18.78125 10 C 18.316406 10.105469 17.988281 10.523438 18 11 L 18 44 C 17.996094 44.359375 18.183594 44.695313 18.496094 44.878906 C 18.808594 45.058594 19.191406 45.058594 19.503906 44.878906 C 19.816406 44.695313 20.003906 44.359375 20 44 L 20 11 C 20.011719 10.710938 19.894531 10.433594 19.6875 10.238281 C 19.476563 10.039063 19.191406 9.941406 18.90625 9.96875 Z M 24.90625 9.96875 C 24.863281 9.976563 24.820313 9.988281 24.78125 10 C 24.316406 10.105469 23.988281 10.523438 24 11 L 24 44 C 23.996094 44.359375 24.183594 44.695313 24.496094 44.878906 C 24.808594 45.058594 25.191406 45.058594 25.503906 44.878906 C 25.816406 44.695313 26.003906 44.359375 26 44 L 26 11 C 26.011719 10.710938 25.894531 10.433594 25.6875 10.238281 C 25.476563 10.039063 25.191406 9.941406 24.90625 9.96875 Z M 30.90625 9.96875 C 30.863281 9.976563 30.820313 9.988281 30.78125 10 C 30.316406 10.105469 29.988281 10.523438 30 11 L 30 44 C 29.996094 44.359375 30.183594 44.695313 30.496094 44.878906 C 30.808594 45.058594 31.191406 45.058594 31.503906 44.878906 C 31.816406 44.695313 32.003906 44.359375 32 44 L 32 11 C 32.011719 10.710938 31.894531 10.433594 31.6875 10.238281 C 31.476563 10.039063 31.191406 9.941406 30.90625 9.96875 Z'%3E%3C/path%3E%3C/svg%3E"
                deleteIcon.addEventListener("mouseover", (event) =>{
                    deleteIcon.style.backgroundColor="rgb(44 43 43)"
                })

                deleteIcon.addEventListener("mouseleave", (event) =>{
                    deleteIcon.style.backgroundColor="rgb(153 153 153)"
                })
                final.appendChild(inner);
                final.appendChild(zoomOut);
                final.appendChild(zoomIn);
                final.appendChild(deleteIcon)
                zoomIn.onclick = (e) => {
                    e.preventDefault();
                    zoomFactor += 0.25
                    regetURL(true);

                    
                };
                zoomOut.onclick = (e) => {
                    e.preventDefault();
                    zoomFactor -= 0.25
                    zoomFactor = Math.max(zoomFactor, 1)
                    regetURL(true);
                    
                };

                deleteIcon.onclick = (e)=>{
                    let outerTr = view.state.tr;
                    view.dispatch(
                        outerTr.deleteRange(
                            getPos(),
                            getPos() + 1
                        )
                    );
                }

                final.addEventListener("mouseover", (event) => {
                    logger.debug("mouseover image")
                    if (type === "platform"){
                        zoomIn.style.scale="1"
                        zoomOut.style.scale="1"
                    }
                    deleteIcon.style.scale="1"
                });
    
                final.addEventListener("mouseleave", (event) => {
                    logger.debug("mouseover image")
                    if (type === "platform"){
                        zoomIn.style.scale="0"
                        zoomOut.style.scale="0"
                    }
                    deleteIcon.style.scale="0"
                });
                return final;

            }

            
        } else {
            //This is for old screenshots!

            const inner = document.createElement("img");

            inner.setAttribute("src", node.attrs.src);
            inner.className += "gigauser-rich-editor-img";

            setStyle(inner, {
                width: "99%",
                minWidth: "50px",
                objectFit: "contain", // maintain image's aspect ratio
                position: "relative",
            });
            return inner;
        }
        // final.appendChild(inner)

    }
}
